import axiosClient from '../axiosClient';
import { APPLICATION_CREATION_API_URL } from '../constants';

const ApplicationCreation = {
  createApplication: async (body: any) => {
    try {
      const response = await axiosClient.post(`${APPLICATION_CREATION_API_URL}`, { ...body });
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  },

  fetchApplications: async() => {
    try {
      const response = await axiosClient.get(APPLICATION_CREATION_API_URL);
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  },
};

export default ApplicationCreation